import { Column } from '@codeparva/ui-components-library';
import React from 'react';
import { AccountSettingsTypes } from '../../AccountSettingsTypes';
import { UpdateAccountNameForm } from '../Form/UpdateAccountNameForm';
import { UpdatePasswordForm } from '../Form/UpdatePasswordForm';
export const AccountSettings = ({
  AccountNameUpdate,
  AccountPasswordUpdate,
  ledgerId,
  ledgerName,
}: AccountSettingsTypes.TAccountNamePassword) => {
  const UpdateAccountNameSection = () => {
    return (
      <div className="updateAccountNameParentSection">
        <div className="titleSection">
          <h5>Set a customized name for this account.</h5>
        </div>
        <UpdateAccountNameForm
          AccountNameUpdate={AccountNameUpdate}
          ledgerId={ledgerId}
          ledgerName={ledgerName}
        />
      </div>
    );
  };

  const UpdatePasswordSection = () => {
    return (
      <div className="updatePasswordParentSection">
        <div className="titleSection">
          <h5>Change Password</h5>
        </div>
        <UpdatePasswordForm AccountPasswordUpdate={AccountPasswordUpdate} />
      </div>
    );
  };

  return (
    <div className="accountSettingsContainer">
      <Column>
        <div className="is-hidden-tablet smallScreenHeading">
          <h5 className="has-text-center">Account Settings</h5>
        </div>
        <UpdateAccountNameSection />
        <UpdatePasswordSection />
      </Column>
    </div>
  );
};
